import { render, staticRenderFns } from "./AdminVisits.vue?vue&type=template&id=73bf3495"
import script from "./AdminVisits.vue?vue&type=script&lang=js"
export * from "./AdminVisits.vue?vue&type=script&lang=js"
import style0 from "./AdminVisits.vue?vue&type=style&index=0&id=73bf3495&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports